import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'rma-buying',
  imports: [TranslocoModule, MatButtonModule],
  templateUrl: './buying.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyingComponent {}
